import React from 'react';
import { useSelector } from 'react-redux';

import { getAIReviewSummary } from '@/redux/selectors/listing/reviews';

import AIReviewSummary from './AIReviewSummary';

const AIReviewSummaryContainer: React.FC = () => {
  const aiReviewSummary = useSelector(getAIReviewSummary);

  if (!aiReviewSummary) {
    return null;
  }

  return <AIReviewSummary items={aiReviewSummary.items} reviewers={aiReviewSummary.reviewers} />;
};

export default AIReviewSummaryContainer;
